import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function Services() {
  const services = [
    {
      icon: 'ri-database-2-line',
      title: 'Storage of Petroleum Products',
      description: 'We provide secure and specialized storage solutions for petroleum products, ensuring the integrity and quality of your goods are maintained. Our facility features a diverse fleet of dedicated fuel storage tanks, each assigned to specific product types.',
      link: '/storage',
      image: 'https://public.readdy.ai/ai/img_res/875d87f99039c9801d4f9d677d90b6ae.jpg',
      features: [
        '100,000 m³ total storage capacity',
        'Dedicated tanks for specific product types',
        'Advanced safety and monitoring systems',
        '24/7 security and surveillance',
        'Quality preservation protocols'
      ]
    },
    {
      icon: 'ri-flask-line',
      title: 'Laboratory Analysis of Petroleum Products',
      description: 'Rigorous quality control is essential in the petroleum industry. Our in-house laboratory provides precise and timely analysis of both incoming and outgoing products. Through continuous monitoring, we compare baseline specifications against actual product indicators.',
      link: '/laboratory',
      image: 'https://readdy.ai/api/search-image?query=Professional%20petroleum%20laboratory%20scientist%20in%20white%20coat%20analyzing%20oil%20samples%20with%20modern%20testing%20equipment%2C%20high-tech%20industrial%20laboratory%20showing%20quality%20control%20testing%20of%20petroleum%20products%20with%20microscopes%20and%20analytical%20instruments%2C%20clean%20modern%20lab%20environment%20with%20professional%20lighting%20and%20safety%20standards%2C%20petroleum%20quality%20analysis%20facility%20with%20advanced%20technology&width=600&height=400&seq=service-lab-new-001&orientation=landscape',
      features: [
        'State-of-the-art testing equipment',
        'Certified laboratory technicians',
        'Comprehensive quality analysis',
        'Fast turnaround times',
        'Compliance with international standards'
      ]
    },
    {
      icon: 'ri-building-line',
      title: 'Tank Leasing',
      description: 'We offer flexible tank leasing options within our modern tank farm, which boasts a total storage capacity of 100,000 m³. Our comprehensive service includes product receipt and delivery. Each tank is outfitted with advanced safety features and a commercial accounting system.',
      link: '/tank-leasing',
      image: 'https://readdy.ai/api/search-image?query=Modern%20petroleum%20storage%20tank%20with%20advanced%20monitoring%20systems%20and%20digital%20displays%2C%20professional%20tank%20farm%20facility%20showing%20real-time%20monitoring%20technology%20and%20safety%20equipment%2C%20large%20white%20storage%20tank%20with%20control%20systems%20and%20professional%20infrastructure%2C%20industrial%20petroleum%20tank%20leasing%20facility%20with%20modern%20architecture%20and%20blue%20sky%20background&width=600&height=400&seq=service-lease-new-001&orientation=landscape',
      features: [
        'Flexible leasing terms',
        'Advanced monitoring systems',
        'Commercial accounting integration',
        'Product receipt and delivery services',
        'Customizable storage solutions'
      ]
    },
    {
      icon: 'ri-ship-line',
      title: 'Maritime Shipping of Petroleum Products',
      description: 'Our maritime shipping capabilities, managed by SHENZHEN TONCENT INT\'L LOGISTICS CO.,LTD, include a controlled fleet of 31 vessels. This fleet comprises 15 self-propelled vessels, 12 non-self-propelled barges, and 4 push tugs.',
      link: '/maritime',
      image: 'https://readdy.ai/api/search-image?query=Large%20petroleum%20oil%20tanker%20vessel%20at%20industrial%20port%20terminal%20loading%20petroleum%20products%2C%20professional%20maritime%20shipping%20operations%20with%20modern%20tanker%20ship%20at%20tank%20farm%20facility%2C%20commercial%20oil%20tanker%20at%20sea%20with%20blue%20ocean%20and%20clear%20sky%2C%20industrial%20petroleum%20maritime%20transport%20showing%20professional%20operations%20and%20safety%20standards&width=600&height=400&seq=service-maritime-new-001&orientation=landscape',
      features: [
        '31-vessel fleet capacity',
        '15 self-propelled vessels',
        '12 non-self-propelled barges',
        '4 push tugs for operations',
        'International shipping routes'
      ]
    },
    {
      icon: 'ri-train-line',
      title: 'Railway Shipping of Petroleum Products',
      description: 'We offer professionally managed railway transportation for petroleum products, ensuring full compliance with all applicable United States and international regulations. Our services are designed to meet the highest industry standards.',
      link: '/railway',
      image: 'https://readdy.ai/api/search-image?query=Railway%20petroleum%20tank%20cars%20on%20tracks%20transporting%20oil%20products%20at%20industrial%20terminal%2C%20professional%20railway%20logistics%20showing%20specialized%20tank%20wagons%20and%20rail%20infrastructure%2C%20petroleum%20railway%20shipping%20with%20multiple%20tank%20cars%20and%20blue%20sky%2C%20commercial%20rail%20transport%20of%20petroleum%20products%20demonstrating%20safety%20compliance%20and%20modern%20logistics&width=600&height=400&seq=service-railway-new-001&orientation=landscape',
      features: [
        'Full regulatory compliance',
        'Specialized tank car fleet',
        'Nationwide rail network access',
        'Real-time tracking systems',
        'Professional logistics management'
      ]
    },
    {
      icon: 'ri-truck-line',
      title: 'Motor Transport Shipping of Petroleum Products',
      description: 'Our road transportation services for petroleum products are conducted in strict adherence to U.S. and international regulatory standards. We prioritize safety and reliability above all, delivering a seamless and cost-effective logistics solution.',
      link: '/motor-transport',
      image: 'https://readdy.ai/api/search-image?query=Modern%20petroleum%20tanker%20truck%20on%20highway%20transporting%20oil%20products%20with%20professional%20safety%20standards%2C%20clean%20commercial%20fuel%20tanker%20truck%20with%20cylindrical%20tank%20and%20safety%20equipment%2C%20professional%20road%20freight%20showing%20petroleum%20product%20transportation%20on%20open%20road%2C%20motor%20transport%20tanker%20demonstrating%20safe%20petroleum%20shipping%20operations%20with%20blue%20sky%20background&width=600&height=400&seq=service-motor-new-001&orientation=landscape',
      features: [
        'Modern tanker truck fleet',
        'GPS tracking and monitoring',
        'Certified professional drivers',
        'Flexible delivery schedules',
        'Safety-first operations'
      ]
    },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <section 
          className="relative bg-cover bg-center h-96 flex items-center"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 20, 60, 0.7), rgba(0, 20, 60, 0.7)), url('https://readdy.ai/api/search-image?query=Comprehensive%20petroleum%20logistics%20operations%20showing%20tank%20farm%20storage%20facility%20with%20white%20cylindrical%20tanks%20and%20industrial%20infrastructure%2C%20professional%20aerial%20view%20of%20oil%20terminal%20with%20storage%20tanks%20and%20shipping%20operations%2C%20modern%20petroleum%20logistics%20facility%20with%20organized%20tank%20farm%20and%20maritime%20port%2C%20industrial%20petroleum%20operations%20demonstrating%20storage%20and%20shipping%20capabilities%20with%20blue%20sky&width=1920&height=400&seq=services-hero-new-001&orientation=landscape')`
          }}
        >
          <div className="max-w-7xl mx-auto px-6 lg:px-12 w-full">
            <h1 className="text-5xl font-bold text-white mb-4">Our Comprehensive Services</h1>
            <p className="text-xl text-gray-200 max-w-2xl">End-to-end petroleum logistics solutions including storage, analysis, leasing, and multi-modal transportation</p>
          </div>
        </section>

        {/* Services Overview */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Complete Petroleum Logistics Solutions</h2>
              <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
                SHENZHEN TONCENT INT'L LOGISTICS CO.,LTD offers a full spectrum of petroleum storage and transportation services. From secure tank farm storage to multi-modal shipping solutions, we provide the infrastructure and expertise to support your petroleum logistics needs across the entire supply chain.
              </p>
            </div>

            <div className="space-y-12">
              {services.map((service, index) => (
                <div key={index} className={`bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-transparent hover:border-teal-500 ${index % 2 === 0 ? '' : ''}`}>
                  <div className={`grid grid-cols-1 lg:grid-cols-2 gap-0 ${index % 2 === 0 ? '' : 'lg:grid-flow-dense'}`}>
                    <div className={`${index % 2 === 0 ? '' : 'lg:col-start-2'}`}>
                      <img 
                        src={service.image} 
                        alt={service.title}
                        className="w-full h-full object-cover object-top min-h-[400px]"
                      />
                    </div>
                    <div className="p-12 flex flex-col justify-center">
                      <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg flex items-center justify-center mb-6">
                        <i className={`${service.icon} text-3xl text-white`}></i>
                      </div>
                      <h3 className="text-3xl font-bold text-gray-900 mb-4">{service.title}</h3>
                      <p className="text-gray-600 mb-6 leading-relaxed text-lg">
                        {service.description}
                      </p>
                      <div className="mb-6">
                        <h4 className="font-bold text-gray-900 mb-3">Key Features:</h4>
                        <ul className="space-y-2">
                          {service.features.map((feature, idx) => (
                            <li key={idx} className="flex items-start gap-2">
                              <i className="ri-check-line text-teal-600 mt-1"></i>
                              <span className="text-gray-700">{feature}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                      <Link 
                        to={service.link} 
                        className="inline-flex items-center text-teal-600 font-semibold hover:text-teal-700 cursor-pointer whitespace-nowrap"
                      >
                        Learn More <i className="ri-arrow-right-line ml-2"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Why Choose Us */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Why Choose Our Services</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Comprehensive capabilities and professional expertise for all your petroleum logistics needs
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-database-2-line text-3xl text-blue-900"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">100,000 m³ Capacity</h3>
                <p className="text-gray-600">Extensive storage infrastructure for petroleum products</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-ship-line text-3xl text-blue-900"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">31 Vessel Fleet</h3>
                <p className="text-gray-600">Comprehensive maritime shipping capabilities</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-3xl text-blue-900"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Full Compliance</h3>
                <p className="text-gray-600">Meeting all international safety and regulatory standards</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-time-line text-3xl text-blue-900"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">24/7 Operations</h3>
                <p className="text-gray-600">Round-the-clock service and support</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-r from-blue-900 via-blue-800 to-teal-900">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center">
            <h2 className="text-4xl font-bold text-white mb-6">Need a Custom Solution?</h2>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
              Contact us to discuss how we can tailor our services to meet your specific requirements
            </p>
            <Link 
              to="/contact" 
              className="inline-block px-8 py-4 bg-teal-500 text-white font-semibold rounded-lg hover:bg-teal-600 transition-colors shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Get in Touch
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
